
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/restaurants",
      function () {
        return require("private-next-pages/search/restaurants.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/restaurants"])
      });
    }
  